import React from "react";

type LatestNumberProps = {
  data: {
    statistics: {
      id: number;
      title: string;
      numbers: string;
      description: string;
    }[];
  };
  isMobile?: boolean;
};
const LatestNumber: React.FC<LatestNumberProps> = ({ data }) => {
  const numbers = data?.statistics || [];
  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-[100px] md:py-[83px] overflow-hidden">
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-start justify-start mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-16 md:gap-[30px] gap-[24px] w-full">
            {numbers?.map((item: any, index: number) => (
              <div
                key={index}
                className={`
                  bg-white w-full icon-container overflow-hidden 
                  col-span-4 ${index % 2 === 1 ? "bg-[url('/images/manufacturing/green-noise.png')]" : "bg-[url('/images/manufacturing/blu-noise.png')]"} 
                  bg-cover bg-center bg-no-repeat   min-h-[187px] md:min-h-[230px] xl:min-h-[291px]
                  max-h-[187px] md:max-h-[230px] xl:max-h-[291px] xl:p-[32px] p-[32px_0_32px_0] 
                  xl:border-t-4 border-t-2 xl:border-b-4 border-b-2 ${index % 2 === 1 ? "border-green-500" : "border-blue-500"}  
                  transition-shadow duration-300
                `}
              >
                <div className="text-center">
                  <div
                    className={`font-extrabold text-[#18A342] mb-0 text-display ${index % 2 === 1 ? "text-green-900" : "text-blue-900"}`}
                  >
                    {item?.numbers}
                  </div>
                  <div className="text-subtitle-3 font-semibold text-primary-text mb-[16px] xl:mb-[32px]">
                    {item?.title}
                  </div>
                  <p className="text-primary-text text-subtitle-3 leading-relaxed mb-0 max-[259px]">
                    {item?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestNumber;
